// @flow

export const EmptyFunc = () => {}

export default EmptyFunc
